import React, { ReactNode } from 'react';

type DropdownProps = {
    open: boolean;
    children: ReactNode;
};

interface DropdownItemProps extends React.HTMLAttributes<HTMLButtonElement> {
    active: boolean;
    children: ReactNode;
}

const Dropdown: React.FC<DropdownProps> = ({ open, children }) => (
    <div className={`dropdown-container ${open ? 'collapsed' : ''}`} aria-hidden={!open}>
        {children}
    </div>
);

export default Dropdown;

export const DropdownItem: React.FC<DropdownItemProps> = ({
    children,
    active,
    ...rest
}) => (
    <button
        className={`dropdown-item ${active ? 'selected' : ''}`}
        tabIndex={active ? -1 : 0}
        {...rest}
    >
        {children}
    </button>
);
